import type { AggregatedIssue } from '@/shared/components/ui/common';

export const SPREADSHEET_VALIDATION_FAILED = 'SPREADSHEET_VALIDATION_FAILED' as const;

export interface SpreadsheetValidationError extends Error {
  code: typeof SPREADSHEET_VALIDATION_FAILED;
  issues: AggregatedIssue[];
  hasCritical: boolean;
  totalRows?: number;
  statusCode?: number;
}

export async function parseSpreadsheetValidationError(
  response: Response,
): Promise<SpreadsheetValidationError | null> {
  const body = (await response
    .clone()
    .json()
    .catch(() => null)) as Record<string, unknown> | null;

  const errorObject =
    body && typeof body.error === 'object' && body.error !== null
      ? (body.error as Record<string, unknown>)
      : null;

  if (errorObject?.code !== SPREADSHEET_VALIDATION_FAILED) return null;

  const message = String(errorObject.message ?? 'Planilha contém erros críticos');
  return Object.assign(new Error(message), {
    code: SPREADSHEET_VALIDATION_FAILED,
    issues: (errorObject.issues as AggregatedIssue[]) ?? [],
    hasCritical: (errorObject.hasCritical as boolean) ?? true,
    totalRows: errorObject.totalRows as number | undefined,
    statusCode: response.status,
  }) as SpreadsheetValidationError;
}
